const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  name: state => state.user.name,
  menu: state => state.user.menu
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js